import type { SupportTicketTimelineEventResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event-response";
import CheckIcon from "@redotech/redo-icons/check.svg";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { EventTimestamp } from "./event-timestamp";
import * as styles from "./timeline-event.module.css";

export const SupportTicketReadEvent = memo(function SupportTicketReadEvent({
  event,
}: {
  event: SupportTicketTimelineEventResponse;
}) {
  return (
    <Flex align="flex-start" className={styles.card} gap="sm">
      <Flex
        align="center"
        className={`${styles.icon} ${styles.iconGreen}`}
        justify="center"
      >
        <CheckIcon />
      </Flex>
      <Flex className={styles.content} dir="column" gap="xxs">
        <Text fontSize="xs" fontWeight="medium" textColor="primary">
          Ticket marked as read
        </Text>
        <EventTimestamp event={event} />
      </Flex>
    </Flex>
  );
});
